export const COUNTRIES_RATES = [
	{
		"rate": "1.50",
		"key": "Afghanistan",
		"Value": "AFGHANISTAN"
	},
	{
		"rate": "1.50",
		"key": "Albania",
		"Value": "ALBANIA"
	},
	{
		"rate": "1.50",
		"key": "Algeria",
		"Value": "ALGERIA"
	},
	{
		"rate": "1.50",
		"key": "American Samoa",
		"Value": "AMERICAN SAMOA"
	},

	{
		"rate": "1.50",
		"key": "Andorra",
		"Value": "ANDORRA"
	},
	{
		"rate": "1.50",
		"key": "Angola",
		"Value": "ANGOLA"
	},

	{
		"rate": "1.50",
		"key": "Anguilla",
		"Value": "ANGUILLA"
	},
	{
		"rate": "1.50",
		"key": "Antarctica",
		"Value": "ANTARCTICA"
	},
	{
		"rate": "1.50",
		"key": "Antigua & Barbuda",
		"Value": "ANTIGUA & BARBUDA"
	},
	{
		"rate": "1.50",
		"key": "Argentina",
		"Value": "ARGENTINA"
	},
	{
		"rate": "1.50",
		"key": "Armenia",
		"Value": "ARMENIA"
	},
	{
		"rate": "1.50",
		"key": "Aruba",
		"Value": "ARUBA"
	},
	{
		"rate": "1.50",
		"key": "Ascension Island",
		"Value": "ASCENSION ISLAND"
	},
	{
		"rate": "1.50",
		"key": "Austria",
		"Value": "AUSTRIA"
	},
	{
		"rate": "1.50",
		"key": "Azerbaijan Republic",
		"Value": "AZERBAIJAN REPUBLIC"
	},
	{
		"rate": "1.50",
		"key": "Bahamas",
		"Value": "BAHAMAS"
	},
	{
		"rate": "1.50",
		"key": "Bahrain",
		"Value": "BAHRAIN"
	},
	{
		"rate": "1.50",
		"key": "Bangladesh",
		"Value": "BANGLADESH"
	},
	{
		"rate": "1.50",
		"key": "Barbados",
		"Value": "BARBADOS"
	},
	{
		"rate": "1.50",
		"key": "Belarus",
		"Value": "BELARUS"
	},
	{
		"rate": "1.50",
		"key": "Belgium",
		"Value": "BELGIUM"
	},
	{
		"rate": "1.50",
		"key": "Belize",
		"Value": "BELIZE"
	},
	{
		"rate": "1.50",
		"key": "Benin",
		"Value": "BENIN"
	},
	{
		"rate": "1.50",
		"key": "Bermuda",
		"Value": "BERMUDA"
	},
	{
		"rate": "1.50",
		"key": "Bhutan",
		"Value": "BHUTAN"
	},
	{
		"rate": "1.50",
		"key": "Bolivia",
		"Value": "BOLIVIA"
	},
	{
		"rate": "1.50",
		"key": "Bosnia & Herzegovina",
		"Value": "BOSNIA & HERZEGOVINA"
	},
	{
		"rate": "1.50",
		"key": "Botswana",
		"Value": "BOTSWANA"
	},
	{
		"rate": "1.50",
		"key": "Brazil",
		"Value": "BRAZIL"
	},
	{
		"rate": "1.50",
		"key": "Brunei",
		"Value": "BRUNEI"
	},
	{
		"rate": "1.50",
		"key": "Bulgaria",
		"Value": "BULGARIA"
	},
	{
		"rate": "1.50",
		"key": "Burkina Faso",
		"Value": "BURKINA FASO"
	},
	{
		"rate": "1.50",
		"key": "Burundi",
		"Value": "BURUNDI"
	},
	{
		"rate": "1.50",
		"key": "Cambodia",
		"Value": "CAMBODIA"
	},
	{
		"rate": "1.50",
		"key": "Cameroon",
		"Value": "CAMEROON"
	},
	{
		"rate": "1.50",
		"key": "Canada",
		"Value": "CANADA"
	},
	{
		"rate": "1.50",
		"key": "Cape Verde",
		"Value": "CAPE VERDE"
	},
	{
		"rate": "1.50",
		"key": "Cayman Islands",
		"Value": "CAYMAN ISLANDS"
	},
	{
		"rate": "1.50",
		"key": "Central African Republic",
		"Value": "CENTRAL AFRICAN REPUBLIC"
	},
	{
		"rate": "1.50",
		"key": "Chad",
		"Value": "CHAD"
	},
	{
		"rate": "1.50",
		"key": "Chile",
		"Value": "CHILE"
	},
	{
		"rate": "1.50",
		"key": "China",
		"Value": "CHINA"
	},
	{
		"rate": "1.50",
		"key": "Colombia",
		"Value": "COLOMBIA"
	},
	{
		"rate": "1.50",
		"key": "Congo",
		"Value": "CONGO"
	},
	{
		"rate": "1.50",
		"key": "Cook Islands",
		"Value": "COOK ISLANDS"
	},
	{
		"rate": "1.50",
		"key": "Costa Rica",
		"Value": "COSTA RICA"
	},
	{
		"rate": "1.50",
		"key": "Croatia",
		"Value": "CROATIA"
	},
	{
		"rate": "1.50",
		"key": "Cuba",
		"Value": "CUBA"
	},
	{
		"rate": "1.50",
		"key": "Cyprus",
		"Value": "CYPRUS"
	},
	{
		"rate": "1.50",
		"key": "Czech Republic",
		"Value": "CZECH REPUBLIC"
	},
	{
		"rate": "1.50",
		"key": "Denmark",
		"Value": "DENMARK"
	},
	{
		"rate": "1.50",
		"key": "Diego Garcia",
		"Value": "DIEGO GARCIA"
	},

	{
		"rate": "1.50",
		"key": "Djibouti",
		"Value": "DJIBOUTI"
	},
	{
		"rate": "1.50",
		"key": "Dominica Islands",
		"Value": "DOMINICA ISLANDS"
	},
	{
		"rate": "1.50",
		"key": "Domonican Republic",
		"Value": "DOMINICAN REPUBLIC"
	},
	{
		"rate": "1.50",
		"key": "East Timor",
		"Value": "EAST TIMOR"
	},
	{
		"rate": "1.50",
		"key": "Ecuador",
		"Value": "ECUADOR"
	},
	{
		"rate": "1.50",
		"key": "Egypt",
		"Value": "EGYPT"
	},
	{
		"rate": "1.50",
		"key": "El Salvador",
		"Value": "EL SALVADOR"
	},
	{
		"rate": "1.50",
		"key": "Equatorial Guinea",
		"Value": "EQUATORIAL GUINEA"
	},
	{
		"rate": "1.50",
		"key": "Eritrea",
		"Value": "ERITREA"
	},
	{
		"rate": "1.50",
		"key": "Estonia",
		"Value": "ESTONIA"
	},
	{
		"rate": "1.50",
		"key": "Ethiopia",
		"Value": "ETHIOPIA"
	},
	{
		"rate": "1.50",
		"key": "Faeroe Islands",
		"Value": "FAEROE ISLANDS"
	},
	{
		"rate": "1.50",
		"key": "Falkland Islands",
		"Value": "FALKLAND ISLANDS"
	},

	{
		"rate": "1.50",
		"key": "Fiji",
		"Value": "FIJI"
	},
	{
		"rate": "1.50",
		"key": "Finland",
		"Value": "FINLAND"
	},
	{
		"rate": "1.50",
		"key": "France",
		"Value": "FRANCE"
	},
	{
		"rate": "1.50",
		"key": "French Polynesia",
		"Value": "FRENCH POLYNESIA"
	},
	{
		"rate": "1.50",
		"key": "FYR Macedonia",
		"Value": "FYR MACEDONIA"
	},
	{
		"rate": "1.50",
		"key": "Gabonese Republic",
		"Value": "GABONESE REPUBLIC"
	},
	{
		"rate": "1.50",
		"key": "Gambia",
		"Value": "GAMBIA"
	},
	{
		"rate": "1.50",
		"key": "Georgia",
		"Value": "GEORGIA"
	},
	{
		"rate": "1.50",
		"key": "Germany",
		"Value": "GERMANY"
	},
	{
		"rate": "1.50",
		"key": "Ghana",
		"Value": "GHANA"
	},
	{
		"rate": "1.50",
		"key": "Gibraltar",
		"Value": "GIBRALTAR"
	},
	{
		"rate": "1.50",
		"key": "Greece",
		"Value": "GREECE"
	},
	{
		"rate": "1.50",
		"key": "Greenland",
		"Value": "GREENLAND"
	},
	{
		"rate": "1.50",
		"key": "Grenada",
		"Value": "GRENADA"
	},
	{
		"rate": "1.50",
		"key": "Guadeloupe",
		"Value": "GUADELOUPE"
	},
	{
		"rate": "1.50",
		"key": "Guam",
		"Value": "GUAM"
	},
	{
		"rate": "1.50",
		"key": "Guatemala",
		"Value": "GUATEMALA"
	},
	{
		"rate": "1.50",
		"key": "Guiana French",
		"Value": "GUIANA FRENCH"
	},
	{
		"rate": "1.50",
		"key": "Guinea Bissau",
		"Value": "GUINEA BISSAU"
	},
	{
		"rate": "1.50",
		"key": "Guinea Republic",
		"Value": "GUINEA REPUBLIC"
	},
	{
		"rate": "1.50",
		"key": "Guyana",
		"Value": "GUYANA"
	},
	{
		"rate": "1.50",
		"key": "Haiti",
		"Value": "HAITI"
	},
	{
		"rate": "1.50",
		"key": "Honduras",
		"Value": "HONDURAS"
	},
	{
		"rate": "1.50",
		"key": "Hong Kong",
		"Value": "HONG KONG"
	},
	{
		"rate": "1.50",
		"key": "Hungary",
		"Value": "HUNGARY"
	},
	{
		"rate": "1.50",
		"key": "Iceland",
		"Value": "ICELAND"
	},
	{
		"rate": "1.50",
		"key": "India",
		"Value": "INDIA"
	},
	{
		"rate": "1.50",
		"key": "Indonesia",
		"Value": "INDONESIA"
	},
	{
		"rate": "1.50",
		"key": "Iran",
		"Value": "IRAN"
	},
	{
		"rate": "1.50",
		"key": "Iraq",
		"Value": "IRAQ"
	},
	{
		"rate": "1.50",
		"key": "Ireland",
		"Value": "IRELAND"
	},
	{
		"rate": "1.50",
		"key": "Israel",
		"Value": "ISRAEL"
	},
	{
		"rate": "1.50",
		"key": "Italy",
		"Value": "ITALY"
	},
	{
		"rate": "1.50",
		"key": "Ivory Coast",
		"Value": "IVORY COAST"
	},
	{
		"rate": "1.50",
		"key": "Jamaica",
		"Value": "JAMAICA"
	},
	{
		"rate": "1.50",
		"key": "Japan",
		"Value": "JAPAN"
	},
	{
		"rate": "1.50",
		"key": "Jordan",
		"Value": "JORDAN"
	},
	{
		"rate": "1.50",
		"key": "Kazakhstan",
		"Value": "KAZAKHSTAN"
	},
	{
		"rate": "1.50",
		"key": "Kenya",
		"Value": "KENYA"
	},
	{
		"rate": "1.50",
		"key": "Kiribati",
		"Value": "KIRIBATI"
	},
	{
		"rate": "1.50",
		"key": "Korea North",
		"Value": "KOREA NORTH"
	},
	{
		"rate": "1.50",
		"key": "Korea South",
		"Value": "KOREA SOUTH"
	},
	// {
	// 	"rate": "1.50",
	// 	"key": "Kosovo",
	// 	"Value": "KOSOVO"
	// },
	{
		"rate": "1.50",
		"key": "Kuwait",
		"Value": "KUWAIT"
	},
	{
		"rate": "1.50",
		"key": "Kyrgyzstan",
		"Value": "KYRGYZSTAN"
	},
	{
		"rate": "1.50",
		"key": "Laos",
		"Value": "LAOS"
	},
	{
		"rate": "1.50",
		"key": "Latvia",
		"Value": "LATVIA"
	},
	{
		"rate": "1.50",
		"key": "Lebanon",
		"Value": "LEBANON"
	},
	{
		"rate": "1.50",
		"key": "Lesotho",
		"Value": "LESOTHO"
	},
	{
		"rate": "1.50",
		"key": "Liberia",
		"Value": "LIBERIA"
	},
	{
		"rate": "1.50",
		"key": "Libya",
		"Value": "LIBYA"
	},
	{
		"rate": "1.50",
		"key": "Liechtenstein",
		"Value": "LIECHTENSTEIN"
	},
	{
		"rate": "1.50",
		"key": "Lithuania",
		"Value": "LITHUANIA"
	},
	{
		"rate": "1.50",
		"key": "Luxembourg",
		"Value": "LUXEMBOURG"
	},
	{
		"rate": "1.50",
		"key": "Macau",
		"Value": "MACAU"
	},
	// {
	// 	"rate": "1.50",
	// 	"key": "Macedonia",
	// 	"Value": "MACEDONIA"
	// },
	{
		"rate": "1.50",
		"key": "Madagascar",
		"Value": "MADAGASCAR"
	},
	{
		"rate": "1.50",
		"key": "Malawi",
		"Value": "MALAWI"
	},
	{
		"rate": "1.50",
		"key": "Malaysia",
		"Value": "MALAYSIA"
	},
	{
		"rate": "1.50",
		"key": "Maldives",
		"Value": "MALDIVES"
	},
	{
		"rate": "1.50",
		"key": "Mali",
		"Value": "MALI"
	},
	{
		"rate": "1.50",
		"key": "Malta",
		"Value": "MALTA"
	},
	{
		"rate": "1.50",
		"key": "Mariana Islands",
		"Value": "MARIANA ISLANDS"
	},
	{
		"rate": "1.50",
		"key": "Marshall Islands",
		"Value": "MARSHALL ISLANDS"
	},
	{
		"rate": "1.50",
		"key": "Martinique",
		"Value": "MARTINIQUE"
	},
	{
		"rate": "1.50",
		"key": "Mauritania",
		"Value": "MAURITANIA"
	},
	{
		"rate": "1.50",
		"key": "Mauritius",
		"Value": "MAURITIUS"
	},
	{
		"rate": "1.50",
		"key": "Mayotte Island",
		"Value": "MAYOTTE ISLAND"
	},
	{
		"rate": "1.50",
		"key": "Mexico",
		"Value": "MEXICO"
	},
	{
		"rate": "1.50",
		"key": "Micronesia",
		"Value": "MICRONESIA"
	},
	// {
	// 	"rate": "1.50",
	// 	"key": "Moldova",
	// 	"Value": "MOLDOVA"
	// },
	{
		"rate": "1.50",
		"key": "Monaco",
		"Value": "MONACO"
	},
	{
		"rate": "1.50",
		"key": "Mongolia",
		"Value": "MONGOLIA"
	},
	// {
	// 	"rate": "1.50",
	// 	"key": "Montenegro",
	// 	"Value": "MONTENEGRO"
	// },
	{
		"rate": "1.50",
		"key": "Montserrat",
		"Value": "MONTSERRAT"
	},

	{
		"rate": "1.50",
		"key": "Morocco",
		"Value": "MOROCCO"
	},
	{
		"rate": "1.50",
		"key": "Mozambique",
		"Value": "MOZAMBIQUE"
	},
	{
		"rate": "1.50",
		"key": "Myanmar",
		"Value": "MYANMAR"
	},
	{
		"rate": "1.50",
		"key": "Nakhodka",
		"Value": "NAKHODKA"
	},
	{
		"rate": "1.50",
		"key": "Namibia",
		"Value": "NAMIBIA"
	},
	{
		"rate": "1.50",
		"key": "Nauru",
		"Value": "NAURU"
	},
	{
		"rate": "1.50",
		"key": "Nepal",
		"Value": "NEPAL"
	},
	{
		"rate": "1.50",
		"key": "Netherlankd Antilles",
		"Value": "NETHERLAND ANTILLES"
	},
	{
		"rate": "1.50",
		"key": "Netherlands",
		"Value": "NETHERLANDS"
	},

	{
		"rate": "1.50",
		"key": "New Caledonia",
		"Value": "NEW CALEDONIA"
	},
	{
		"rate": "1.50",
		"key": "New Zealand",
		"Value": "NEW ZEALAND"
	},
	{
		"rate": "1.50",
		"key": "Nicaragua",
		"Value": "NICARAGUA"
	},
	{
		"rate": "1.50",
		"key": "Niger",
		"Value": "NIGER"
	},
	{
		"rate": "1.50",
		"key": "Nigeria",
		"Value": "NIGERIA"
	},
	{
		"rate": "1.50",
		"key": "Niue Island",
		"Value": "NIUE ISLAND"
	},
	{
		"rate": "1.50",
		"key": "Norfolk Island",
		"Value": "NORFOLK ISLAND"
	},
	{
		"rate": "1.50",
		"key": "Norway",
		"Value": "NORWAY"
	},
	{
		"rate": "1.50",
		"key": "Oman",
		"Value": "OMAN"
	},
	{
		"rate": "1.50",
		"key": "Pakistan",
		"Value": "PAKISTAN"
	},
	{
		"rate": "1.50",
		"key": "Palau",
		"Value": "PALAU"
	},
	// {
	// 	"rate": "1.50",
	// 	"key": "Palestine",
	// 	"Value": "PALESTINE"
	// },
	{
		"rate": "1.50",
		"key": "Panama",
		"Value": "PANAMA"
	},
	{
		"rate": "1.50",
		"key": "Papua New Guinea",
		"Value": "PAPUA NEW GUINEA"
	},
	{
		"rate": "1.50",
		"key": "Paraguay",
		"Value": "PARAGUAY"
	},
	{
		"rate": "1.50",
		"key": "Peru",
		"Value": "PERU"
	},
	{
		"rate": "1.50",
		"key": "Philippines",
		"Value": "PHILIPPINES"
	},
	{
		"rate": "1.50",
		"key": "Poland",
		"Value": "POLAND"
	},
	{
		"rate": "1.50",
		"key": "Portugal",
		"Value": "PORTUGAL"
	},
	{
		"rate": "1.50",
		"key": "Puerto Rico",
		"Value": "PUERTO RICO"
	},
	{
		"rate": "1.50",
		"key": "Qatar",
		"Value": "QATAR"
	},
	{
		"rate": "1.50",
		"key": "Republic Of Moldova",
		"Value": "REPUBLIC OF MOLDOVA"
	},
	{
		"rate": "1.50",
		"key": "Reunion",
		"Value": "REUNION"
	},
	{
		"rate": "1.50",
		"key": "Romania",
		"Value": "ROMANIA"
	},
	{
		"rate": "1.50",
		"key": "Russia",
		"Value": "RUSSIA"
	},
	// {
	// 	"rate": "1.50",
	// 	"key": "Rwanda",
	// 	"Value": "RWANDA"
	// },
	// {
	// 	"rate": "1.50",
	// 	"key": "San Marino",
	// 	"Value": "SAN MARINO"
	// },
	{
		"rate": "1.50",
		"key": "Sao Tome & Principe",
		"Value": "SAO TOME & PRINCIPE"
	},
	{
		"rate": "1.50",
		"key": "Saudi Arabia",
		"Value": "SAUDI ARABIA"
	},
	{
		"rate": "1.50",
		"key": "Senegal",
		"Value": "SENEGAL"
	},
	{
		"rate": "1.50",
		"key": "Serbia Montg",
		"Value": "SERBIA MONTG"
	},
	{
		"rate": "1.50",
		"key": "Seychelles",
		"Value": "SEYCHELLES"
	},
	{
		"rate": "1.50",
		"key": "Sierra Leone",
		"Value": "SIERRA LEONE"
	},
	{
		"rate": "1.50",
		"key": "Singapore",
		"Value": "SINGAPORE"
	},
	{
		"rate": "1.50",
		"key": "Slovakia",
		"Value": "SLOVAKIA"
	},
	{
		"rate": "1.50",
		"key": "Slovenia",
		"Value": "SLOVENIA"
	},
	{
		"rate": "1.50",
		"key": "Solomon Islands",
		"Value": "SOLOMON ISLANDS"
	},
	{
		"rate": "1.50",
		"key": "Somalia",
		"Value": "SOMALIA"
	},
	{
		"rate": "1.50",
		"key": "South Africa",
		"Value": "SOUTH AFRICA"
	},
	// {
	// 	"rate": "1.50",
	// 	"key": "South Sudan",
	// 	"Value": "SOUTH SUDAN"
	// },
	{
		"rate": "1.50",
		"key": "Spain",
		"Value": "SPAIN"
	},
	{
		"rate": "1.50",
		"key": "Sri Lanka",
		"Value": "SRI LANKA"
	},
	{
		"rate": "1.50",
		"key": "St Helena",
		"Value": "ST HELENA"
	},
	{
		"rate": "1.50",
		"key": "St Kitts & Nevis",
		"Value": "ST KITTS & NEVIS"
	},
	{
		"rate": "1.50",
		"key": "St Lucia",
		"Value": "ST LUCIA"
	},
	{
		"rate": "1.50",
		"key": "St Pierre AND Miquelon",
		"Value": "ST PIERRE & MIQUELON"
	},
	{
		"rate": "1.50",
		"key": "St Vincent & Bequia",
		"Value": "ST VINCENT & BEQUIA"
	},
	{
		"rate": "1.50",
		"key": "Sudan",
		"Value": "SUDAN"
	},
	{
		"rate": "1.50",
		"key": "Suriname",
		"Value": "SURINAME"
	},
	{
		"rate": "1.50",
		"key": "Swaziland",
		"Value": "SWAZILAND"
	},
	{
		"rate": "1.50",
		"key": "Sweden",
		"Value": "SWEDEN"
	},
	{
		"rate": "1.50",
		"key": "Switzerland",
		"Value": "SWITZERLAND"
	},
	{
		"rate": "1.50",
		"key": "Syria",
		"Value": "SYRIA"
	},
	{
		"rate": "1.50",
		"key": "Taiwan",
		"Value": "TAIWAN"
	},
	{
		"rate": "1.50",
		"key": "Tajikistan",
		"Value": "TAJIKISTAN"
	},
	{
		"rate": "1.50",
		"key": "Tanzania",
		"Value": "TANZANIA"
	},
	{
		"rate": "1.50",
		"key": "Thailand",
		"Value": "THAILAND"
	},
	{
		"rate": "1.50",
		"key": "Togolese Republic",
		"Value": "TOGOLESE REPUBLIC"
	},
	{
		"rate": "1.50",
		"key": "Tokelau",
		"Value": "TOKELAU"
	},
	{
		"rate": "1.50",
		"key": "Tonga",
		"Value": "TONGA"
	},
	{
		"rate": "1.50",
		"key": "Trinidad AND Tobago",
		"Value": "TRINIDAD & TOBAGO"
	},
	{
		"rate": "1.50",
		"key": "Tunisia",
		"Value": "TUNISIA"
	},
	{
		"rate": "1.50",
		"key": "Turkey",
		"Value": "TURKEY"
	},
	{
		"rate": "1.50",
		"key": "Turkmenistan",
		"Value": "TURKMENISTAN"
	},
	{
		"rate": "1.50",
		"key": "Turks & Caicos Islands",
		"Value": "TURKS & CAICOS ISLANDS"
	},
	{
		"rate": "1.50",
		"key": "Tuvalo",
		"Value": "TUVALU"
	},
	{
		"rate": "1.50",
		"key": "Uganda",
		"Value": "UGANDA"
	},
	{
		"rate": "1.50",
		"key": "Ukraine",
		"Value": "UKRAINE"
	},
	{
		"rate": "1.50",
		"key": "United Arab Emirates",
		"Value": "UNITED ARAB EMIRATES"
	},
	{
		"rate": "1.50",
		"key": "United Kingdom",
		"Value": "UNITED KINGDOM"
	},
	{
		"rate": "1.50",
		"key": "United State Of America",
		"Value": "UNITED STATES OF AMERICA"
	},
	{
		"rate": "1.50",
		"key": "Uruguay",
		"Value": "URUGUAY"
	},
	{
		"rate": "1.50",
		"key": "Uzbekistan",
		"Value": "UZBEKISTAN"
	},
	{
		"rate": "1.50",
		"key": "Vanuatu",
		"Value": "VANUATU"
	},
	{
		"rate": "1.50",
		"key": "Vatican City",
		"Value": "VATICAN CITY"
	},
	{
		"rate": "1.50",
		"key": "Venezuela",
		"Value": "VENEZUELA"
	},
	{
		"rate": "1.50",
		"key": "Vietnam",
		"Value": "VIETNAM"
	},
	{
		"rate": "1.50",
		"key": "Virgin Islands (Br)",
		"Value": "VIRGIN ISLANDS (BR)"
	},
	{
		"rate": "1.50",
		"key": "Virgin Islands (Us)",
		"Value": "VIRGIN ISLANDS (US)"
	},
	{
		"rate": "1.50",
		"key": "Wallis & Futuna",
		"Value": "WALLIS & FUTUNA"
	},
	{
		"rate": "1.50",
		"key": "Western Samoa",
		"Value": "WESTERN SAMOA"
	},
	{
		"rate": "1.50",
		"key": "Yemen",
		"Value": "YEMEN"
	},
	{
		"rate": "1.50",
		"key": "Zaire",
		"Value": "ZAIRE"
	},
	{
		"rate": "1.50",
		"key": "Zambia",
		"Value": "ZAMBIA"
	},
	{
		"rate": "1.50",
		"key": "Zimbabwe",
		"Value": "ZIMBABWE"
	}
];
